module.exports = __webpack_public_path__ + "img/sidebar_titleTwo.bdce636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/sidebar_titleTwo.jpg
// module id = xuhd
// module chunks = 1